import { ref } from 'vue'
import { defineStore } from 'pinia'

/**
 * PageTitle Store
 * 用于管理导航栏中的页面标题
 */
export const usePageTitleStore = defineStore('pageTitle', () => {
  /**
   * 当前页面标题key
   * 对应路由名称,用于从国际化文件中查找翻译
   * 例如: 'query' → $t('route.query')
   */
  const currentTitle = ref('query')

  /**
   * 设置页面标题
   * @param title - 页面标题key,对应路由名称
   */
  const setPageTitle = (title: string) => {
    currentTitle.value = title
  }

  return {
    currentTitle,
    setPageTitle
  }
})
